"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.denseMenuItem = exports.menuItem = exports.textField = exports.errorIcon = exports.calendarIcon = void 0;

var _react = require("@emotion/react");

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n  min-height: 40px;\n  ", "\n"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n  justify-content: space-between;\n  & > svg {\n    visibility: ", ";\n  }\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  margin: 16px 0;\n  min-width: 148px;\n  & > div.MuiInputBase-root > div.MuiSelect-root > svg {\n    visibility: hidden !important;\n    height: 0;\n  }\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  color: ", ";\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  color: ", ";\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var calendarIcon = function calendarIcon(_ref) {
  var colors = _ref.colors;
  return (0, _react.css)(_templateObject(), colors.neutral[400]);
};

exports.calendarIcon = calendarIcon;

var errorIcon = function errorIcon(_ref2) {
  var colors = _ref2.colors;
  return (0, _react.css)(_templateObject2(), colors.danger);
};

exports.errorIcon = errorIcon;
var textField = (0, _react.css)(_templateObject3());
exports.textField = textField;

var menuItem = function menuItem(isSelectedItem) {
  return (0, _react.css)(_templateObject4(), isSelectedItem === true ? 'visible' : 'hidden');
};

exports.menuItem = menuItem;

var denseMenuItem = function denseMenuItem(isSelectedItem) {
  return (0, _react.css)(_templateObject5(), menuItem(isSelectedItem));
};

exports.denseMenuItem = denseMenuItem;